import { createTheme } from '@mui/material/styles';

// Medical-themed color palette
export const colors = {
  // Primary and secondary colors
  primary: {
    light: '#6687D3',
    main: '#003294',  // Deep navy blue - primary brand color (0, 50, 148)
    dark: '#00205F', 
    contrastText: '#FFFFFF'
  },
  secondary: {
    light: '#E2C3D7',
    main: '#A55A7E',  // Burgundy - secondary accent color
    dark: '#7A3959',
    contrastText: '#FFFFFF'
  },
  // Anatomical district colors for pathology categories
  districts: {
    orl: '#E57373',                  // Softer red for ORL infections
    otiti: '#FFAB91',                // Soft salmon for ear infections
    alteVieRespiratorie: '#90CAF9',  // Light blue for upper respiratory
    respiratory: '#64B5F6',          // Softer blue for lower respiratory
    ocular: '#81C784',               // Softer green for eye infections
    skin: '#F06292',                 // Soft pink for skin/tissues
    sti: '#5C6BC0',                  // Indigo instead of black for STIs
    urinary: '#FFD54F',              // Softer yellow for urinary
    other: '#A1887F'                 // Softer brown for others
  },
  // AWaRe classification colors for antibiotics
  aware: {
    access: '#4CAF50',         // Green - Access group antibiotics
    watch: '#FF9800',          // Orange - Watch group antibiotics
    reserve: '#F44336',        // Red - Reserve group antibiotics
    unclassified: '#9E9E9E'    // Grey - Not classified
  },
  // UI colors
  background: {
    default: '#F8F9FA',       // Very light cool gray
    paper: '#FFFFFF'
  },
  text: {
    primary: '#212529',        // Dark gray for primary text
    secondary: '#6C757D'       // Medium gray for secondary text
  },
  error: {
    main: '#DC3545'           // Bootstrap-style red for errors
  },
  warning: {
    main: '#FFC107'           // Amber for warnings
  },
  info: {
    main: '#0DCAF0'           // Light blue for info
  },
  success: {
    main: '#198754'           // Bootstrap-style green for success
  },
};

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: colors.primary,
    secondary: colors.secondary,
    error: {
      main: colors.error.main,
    },
    warning: {
      main: colors.warning.main,
    },
    info: {
      main: colors.info.main,
    },
    success: {
      main: colors.success.main,
    },
    background: colors.background,
    text: colors.text,
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 500,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 500,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 500,
      fontSize: '1.75rem',
    },
    body1: {
      fontSize: '1rem',
    },
    body2: {
      fontSize: '0.875rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 4px rgba(0, 0, 0, 0.08)',
        },
      },
    },
  },
});

export default theme;
